import Modal from 'bootstrap/js/dist/modal';
import 'htmx.org';
import CustomerEmailCapturedEvent from '../../events/customer-email-captured-event';

const initModals = () => {
    const checkNifForm = document.getElementById('club-member-acquisition-check-nif-form');
    const loginForm = document.getElementById('club-member-acquisition-login-form');
    const registerForm = document.getElementById('club-member-acquisition-register-form');
    const joinClubForm = document.getElementById('club-member-acquisition-join-club-form');
    const successElement = document.getElementById('club-member-acquisition-success-modal');

    const checkNifModal = checkNifForm ? new Modal(checkNifForm, {}) : null;
    const loginModal = loginForm ? new Modal(loginForm, {}) : null;
    const registerModal = registerForm ? new Modal(registerForm, {}) : null;
    const joinClubModal = joinClubForm ? new Modal(joinClubForm, {}) : null;
    const successModal = successElement ? new Modal(successElement, {}) : null;

    return [checkNifModal, loginModal, registerModal, joinClubModal, successModal];
};

const showModal = (targetModal, modals) => {
    if (targetModal == null) {
        return;
    }

    modals.forEach((modal) => {
        if (modal == null) {
            return;
        }

        if (modal === targetModal) {
            modal.show();
        } else {
            modal.hide();
        }
    });
};

document.addEventListener('alpine:init', () => {
    const modals = initModals();
    const [checkNifModal, loginModal, registerModal, , successModal] = modals;

    window.Alpine.data('Guest', () => ({
        nif: '',
        customerType: null,
        checkNif() {
            this.$refs.checkNifButton.classList.add('loading');
            this.hideNifValidationError();

            fetch('/club-member-acquisition/check-nif', {
                method: 'POST',
                body: new URLSearchParams({ nif: this.nif }),
            })
                .then((response) => {
                    if (!response.ok) {
                        return Promise.reject();
                    }

                    return response.json();
                })
                .then(({ nif, customerType, step }) => {
                    document.dispatchEvent(new CustomEvent('Club_Member_Acquisition_Lead'));
                    this.nif = nif;
                    this.customerType = customerType;

                    if (step === 'login') {
                        this.showLogin();
                    } else {
                        this.showRegister();
                    }
                })
                .catch(() => {
                    document.dispatchEvent(new CustomEvent('Club_Member_Acquisition_Lead_Error'));
                    this.showNifValidationError();
                })
                .finally(() => this.$refs.checkNifButton.classList.remove('loading'));
        },
        showCheckNif() {
            showModal(checkNifModal, modals);
        },
        showLogin() {
            showModal(loginModal, modals);
        },
        showRegister() {
            showModal(registerModal, modals);
        },
        showNifValidationError() {
            this.$refs.nifValidationInput.classList.add('error');
            this.$refs.nifValidationError.classList.remove('d-none');
        },
        hideNifValidationError() {
            this.$refs.nifValidationInput.classList.remove('error');
            this.$refs.nifValidationError.classList.add('d-none');
        },
    }));

    document.body.addEventListener('htmx:beforeRequest', (event) => {
        if (event.detail.elt.classList.contains('btn')) {
            event.detail.elt.classList.add('loading');
        }
    });

    document.body.addEventListener('htmx:afterRequest', (event) => {
        if (event.detail.elt.classList.contains('btn')) {
            event.detail.elt.classList.remove('loading');
        }
    });

    document.body.addEventListener('htmx:configRequest', function (event) {
        const path = event.detail.path ?? '';
        const isRegisterFormPath = path === '/club-member-acquisition/register-form' || path.startsWith('/club-member-acquisition/register-form/');

        if (!isRegisterFormPath || event.detail.verb !== 'post') {
            return;
        }

        const form = event.detail.elt.closest('form');
        const emailInput = form?.querySelector('input[name="sylius_customer_registration[email]"]');

        if (emailInput && typeof emailInput.value === 'string' && emailInput.value.trim() !== '') {
            document.dispatchEvent(new CustomerEmailCapturedEvent(emailInput.value));
        }
    });

    document.body.addEventListener('htmx:beforeOnLoad', function (event) {
        const request = event.detail.requestConfig;
        const response = event.detail.xhr;
        const path = request.path ?? '';
        const isRegisterFormPath = path === '/club-member-acquisition/register-form' || path.startsWith('/club-member-acquisition/register-form/');
        const isJoinClubFormPath = path === '/club-member-acquisition/join-club-form' || path.startsWith('/club-member-acquisition/join-club-form/');

        if ((isRegisterFormPath || isJoinClubFormPath) && request.verb === 'post' && response.status === 200) {
            window.dataLayerPushDeferred({ event: 'sign_up', event_type: 'dni-socio' });
            event.preventDefault();
            showModal(successModal, modals);
        }

        if (isJoinClubFormPath && request.verb === 'post' && response.status === 422) {
            document.getElementById('join-club-nif-error').classList.remove('d-none');
            event.preventDefault();
        }
    });

    successModal?._element.addEventListener('hide.bs.modal', (event) => {
        event.preventDefault();
        window.location.reload();
    });
});
